import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import 'src/assets/donutStylesAnimation.css'

export const CounterCard = ({ count, isLoading, border, redirectTo }) => {
  const borderStyle = isLoading ? {} : { border: border }
  return (
    <Box
      position={'relative'}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      width={'100%'}
      height={'170px'}
    >
      <Box className={`donut_car ${isLoading ? 'loading' : ''}`} style={borderStyle}></Box>
      <Button
        component={Link}
        to={redirectTo}
        onClick={(e) => e.stopPropagation()}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span style={{ fontSize: '2em', fontWeight: 'bold' }}>{count}</span>
      </Button>
    </Box>
  )
}
